import { Routes } from '@angular/router';
import { requireLoggedInCanMatch } from './components/auth/auth-routing.guards';

export const ROUTE_PATH_FORBIDDEN = 'forbidden';
const ROUTE_PATH_NOT_FOUND = 'not-found';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/welcome-header',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/auth/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./components/auth/logout/logout.component').then(
        (m) => m.LogoutComponent,
      ),
  },
  {
    path: ROUTE_PATH_FORBIDDEN,
    loadComponent: () =>
      import('./components/errors/forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent,
      ),
  },
  {
    path: 'welcome-header',
    loadChildren: () =>
      import('./components/landing-page/landing-page.routes').then(
        (m) => m.landingPageRoutes,
      ),
  },
  {
    path: 'submission-history',
    canMatch: [requireLoggedInCanMatch],
    loadComponent: () =>
      import('./features/submission-history/submission-history.component').then(
        (m) => m.SubmissionHistoryComponent,
      ),
  },
  {
    path: ROUTE_PATH_NOT_FOUND,
    loadComponent: () =>
      import('./components/errors/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
  },
  {
    path: '**',
    redirectTo: `/${ROUTE_PATH_NOT_FOUND}`,
  },
];
